import { render, staticRenderFns } from "./DetailHeaderBtns.vue?vue&type=template&id=d297c520&scoped=true&"
import script from "./DetailHeaderBtns.vue?vue&type=script&lang=ts&"
export * from "./DetailHeaderBtns.vue?vue&type=script&lang=ts&"
import style0 from "./DetailHeaderBtns.vue?vue&type=style&index=0&id=d297c520&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d297c520",
  null
  
)

export default component.exports